import React from 'react';
import { observer } from 'mobx-react';
import { Box, useTheme } from '@mui/material';
import LoadMoreButton from '../LoadMoreButton';
import { InboxesTreesViewName } from './const';
import InboxTree from './InboxTree';
import { PreFilledTreeName, MyOwnTransfersTreeName, TasksTreeName, OtherInboxesTreeName } from './InboxTree/const';
import { useData } from './hooks';
import { ListColumnOrRowContainer } from '10.quickConnect.app/components/domain/Home/styles';

const InboxesTrees = () => {
  const theme = useTheme();
  const {
    OthersStore,
    PreFilledStore,
    MyOwnTransfersStore,
    TasksStore,
    prefilledItemsTitle,
    myOwnTransfersTitle,
    tasksItemsTitle,
    othersItemsTitle,
    t,
    itemsShown,
    totalItemsCount,
    hasMoreItems,
    loadMoreItems,
  } = useData();
  return (
    <Box
      data-cy={InboxesTreesViewName}
      sx={{
        ...ListColumnOrRowContainer(theme),
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row' },
          overflowY: 'auto',
        }}
      >
        <InboxTree
          store={PreFilledStore}
          title={prefilledItemsTitle}
          treeName={PreFilledTreeName}
          cle={PreFilledTreeName}
        />
        {MyOwnTransfersStore.items && MyOwnTransfersStore.items.length > 0 && (
          <InboxTree
            store={MyOwnTransfersStore}
            title={myOwnTransfersTitle}
            treeName={MyOwnTransfersTreeName}
            cle={MyOwnTransfersTreeName}
          />
        )}
        {TasksStore.items && TasksStore.items.length > 0 && (
          <InboxTree store={TasksStore} title={tasksItemsTitle} treeName={TasksTreeName} cle={t('tasks.subFolder')} />
        )}
        {OthersStore.items && OthersStore.items.length > 0 && (
          <InboxTree
            store={OthersStore}
            title={othersItemsTitle}
            treeName={OtherInboxesTreeName}
            cle={t('qcapp_inbox_item_category_not_found')}
          />
        )}
      </Box>
      <LoadMoreButton
        itemsShown={itemsShown}
        totalItemsCount={totalItemsCount}
        hasMoreItems={hasMoreItems}
        onLoadMore={loadMoreItems}
      />
    </Box>
  );
};
export default observer(InboxesTrees);
